<template>
  <div class="account">
    <Header titles="账号信息"></Header>
    <div class="option-list">
      <div class="option">
        <Uploader class="upd-f" :after-read="afterRead">
          <div class="option-children">
            <div>头像</div>
            <div class="toumo">
              <img class="op-tx" :src="user.avatarurl || avatar" alt="">
              <img class="acc-rigth" src="@/assets/image/cright.png" alt="">
            </div>
          </div>
        </Uploader>
      </div>
      <div class="option">
        <div class="option-children">
          <div class="accbl">昵称</div>
          <div class="toumo accolor">
            <div class="name-ring">{{user.username}}</div>
            <img class="acc-rigth" src="@/assets/image/cright.png" alt="">
          </div>
        </div>
      </div>
      <div class="option">
        <div to="userin" class="option-children">
          <div class="accbl">账号</div>
          <div class="toumo accolor">
            <div class="name-ring">{{user.mobile}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserInfo} from '@/api/api/user'
import Header from '@/components/header'
const defaultAvatar = require('@/assets/image/head.jpg')
import { Uploader, Toast } from 'vant'
import { upheade } from '@/api/api/upload'

export default {
  data() {
    return {
      user: {},
      avatar: defaultAvatar
    }
  },
  components: {
    Header,
    Uploader
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      getUserInfo().then(res => {
        this.user = res.data.data
        this.user.avatarurl = this.user.avatarurl + '?n=' + Math.floor(Math.random() * 100)
      })
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (file.file.size > 5242880) return Toast('图片不能大于5M')
      const form = new FormData()
      form.append('avatar', file.file, file.file.name)
      upheade(form).then(res => {
        // console.log(res.data)
        if (res.data.errorCode == 0) {
          Toast({
            type: 'success',
            message: '上传成功',
            duration: 1000
          })
          this.user.avatarurl = res.data.data.avatar +'?n='+ Math.floor(Math.random() * 100)
        } else {
          Toast({
            type: 'success',
            message: '上传失败',
            duration: 1000
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.account {
  padding-top: 44px;
  min-height: 100%;
  background: #F6F6F4;
  .option-list {
    .option {
      background: white;
      height: 60px;
      padding-left: 20px;
      color: black;
      .option-children {
        font-size: 15px;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        padding-right: 14px;
        height: 60px;
        align-items: center;
        .toumo {
          display: flex;
          align-items: center;
          .name-ring {
            margin-right: 20px;
          }
          .acc-rigth {
            width: 8px;
            height: 14px;
          }
          .op-tx {
            width: 32px;
            height: 32px;
            margin-right: 20px;
          }
        }
        .accolor {
          color: #999;
        }
        
      }
    }
    padding-top: 10px;
  }
  .accbl {
    color: black;
  }
  .upd-f {
    display: block;
    .upd {
      font-size: 24px;
    }
    .van-uploader__input-wrapper {
      width: 100%;
    }
  }

}
</style>